<template>
  <div>
    <portal to="cardActions">
      <div class="my-2">
        <v-radio-group row v-model="selectedType">
          <v-radio value="sections" label="ICD10 - Capitulos e Secções" />
          <v-radio value="dignostics" label="ICD10 - Capitulos e Diagnósticos" />
        </v-radio-group>
        <span>Ver:</span>
        <v-layout align-center>
          <v-flex xs7>
            <v-radio-group v-model="selectedAmount" class="mt-0" hide-details row>
              <v-radio label="Todos" value="all" />
              <v-radio label="Top 5" value="5" />
              <v-radio label="Top 10" value="10" />
            </v-radio-group>
          </v-flex>
          <v-flex xs5>
            <span class="caption grey--text left">Filtrar por Capitulo</span><br />
            <div style="max-width: 200px">
            <v-select
              :items="chaptersAndDiagnostics"
              item-text="chapter_description"
              v-model="filterByChapter"
              clearable
              solo
              dense
              hide-details
              class="thin-border dense truncate"
            ></v-select>
            </div>
          </v-flex>
        </v-layout>
      </div>
    </portal>
    <table
      :style="cssVars"
      :class="style.borders ? 'bordered' : ''"
      class="styled-table"
    >
      <template v-for="(chapter, key) in chaptersAndDiagnostics">
        <tr v-if="!displayRow(0, chapter.chapter_description)" :key="key" style="border-top: 1px solid #ccc;">
          <td
            style="padding: 10px 15px; width: 100%"
            class="categ-title"
          >
          {{chapter.roman}} {{chapter.chapter_description}} ({{chapter.chapter_code}})
          </td>
          <td class="categ-title" v-text="selectedType === 'sections' ? chapter.sectionSum : chapter.diagnosticSum"></td>
        </tr>
        <template v-for="(section, index) in chapter.sections">
          <tr
            :key="section.section_code+index+key"
            v-if="selectedType === 'sections' && !displayRow(index, chapter.chapter_description)"
          >
            <td class="subcateg-title pl-4">
              <span>{{section.section_description}} ({{section.section_code}})</span>
            </td>
            <td>{{section.count}}</td>
          </tr>
        </template>
        <template v-for="(section, index) in chapter.diagnostics">
          <tr
            v-if="selectedType === 'dignostics' && !displayRow(index, chapter.chapter_description)"
            :key="section.section_code+index"
          >
            <td class="subcateg-title pl-4">
              <span>{{section.description}} ({{section.section_code}})</span>
            </td>
            <td>{{section.count}}</td>
          </tr>
        </template>
      </template>
    </table>
  </div>
</template>

<script>
import icd10Chapters from '@/content/icd/icd-10-cm-chapters.json'
import icd10Sections from '@/content/icd/icd-10-cm-sections.json'
import helpers from '../mixins/statsHelperFunc'
export default {
  props: {
    logs: { type: Array },
    row1: { type: Object }
  },
  mixins: [helpers],
  data() {
    return {
      selectedType: 'sections',
      selectedAmount: 'all',
      filterByChapter: null,
      style: {
        borders: true,
        borderColor: '#cccccc',
        colors: ['#ffffff']
      },
    }
  },
  computed: {
    cssVars() {
      return {
        '--bg-color': this.style.colors[0],
        '--bg-light-color': this.style.colors[0] + 20,
        '--categ-color': this.style.colors[0] + 99,
        '--subcateg-color': this.style.colors[0] + 60,
        '--border-collapse': this.style.borders ? 'collapse' : 'inherit',
        '--border-color': this.style.borderColor,
        '--accent-border-color': this.style.borderColor + 50
      }
    },
    sections() {
      const newSections = icd10Sections.map(section => {
        section.min = section['section_code'].split('-')[0]
        section.max = section['section_code'].split('-')[1]
        return section
      })
      return newSections
    },
    chaptersAndDiagnostics() {
      let newChapters = icd10Chapters.map((chapter, index) => {
        chapter.min = chapter['chapter_code'].split('-')[0]
        chapter.max = chapter['chapter_code'].split('-')[1]
        chapter.roman = this.romanize(index+1)
        chapter.sections = []
        chapter.diagnostics = []
        this.sections.map(section => {
          if(section.min >= chapter.min && section.min <= chapter.max) {
            section.count = this.countSection(section)
            if(section.count > 0) {
              chapter.sections.push(section)
            }
          }
        })
        let diagnostics = []
        this.ICD10logs(this.row1.id).map(log => {
          log[this.row1.id].map(diagnostic => {
            const code = diagnostic.split(':')[0]
            if(code >= chapter.min && code <= chapter.max) {
              const index = diagnostics.findIndex(item => item.section_code === code)
              if(index !== -1) {
                diagnostics[index].count++
              } else {
                diagnostics.push({
                  section_code: code,
                  count: 1,
                  description: diagnostic.split(':')[1]
                })
              }
            }
            chapter.diagnostics = diagnostics
            chapter.diagnostics.sort((a, b) =>  b.count - a.count)
          })
        })
        if(chapter.sections.length !== 0) {
          chapter.sectionSum = chapter.sections.reduce((a, b) => {return a + b['count']}, 0)
        }
        if(chapter.diagnostics.length !== 0) {
          chapter.diagnosticSum = chapter.diagnostics.reduce((a, b) => {return a + b['count']}, 0)
        }
        return chapter
      })
      newChapters = newChapters.filter(chapter => chapter.sections.length !== 0)
      return newChapters
    },
  },
  methods: {
    countSection(section) {
      let count = 0
      this.ICD10logs(this.row1.id).map(log => {
        log[this.row1.id].map(diagnostic => {
          const code = diagnostic.split(':')[0]
          if(code >= section.min && code <= section.max) {
            count++
          }
        })
      })
      return count
    },
    displayRow(key, description) {
      if(this.filterByChapter && description !== this.filterByChapter) {
        return true
      }
      else if(this.selectedAmount !== 'all') {
        return key+1 > this.selectedAmount
      } else {
        return false
      }
    }
  },
  mounted() {
    this.$root.$emit('isTable', true)
    this.$root.$on('selectedStyle', style => {
      this.style = style
    })
  },
}
</script>

<style>
.styled-table {
  font-size: 0.9em;
  font-family: sans-serif;
  width: 100%;
  border-collapse: var(--border-collapse);
}
.styled-table.bordered td, .styled-table.bordered thead{
  border-bottom: 1px solid var(--border-color);
}
.styled-table thead tr {
  background-color: var(--bg-color) !important;
  text-align: left;
}
.styled-table th,
.styled-table td {
  padding: 12px 15px;
  text-align: center;
  vertical-align: middle;
}

.styled-table td.accent-color {
  background-color: var(--accent-color);
}

.styled-table tr:nth-of-type(even) {
  background-color: var(--bg-light-color);
}

.styled-table tr:last-of-type {
  border-bottom: 2px solid #009879;
}
.styled-table td {
  text-align: left !important;
}
.truncate .v-select__selection--comma {
  text-overflow: ellipsis;
  font-size: 12px;
  width: 125px;
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
}


</style>